import React from 'react';
import { FeedList } from './FeedList';

export const EventsList: React.FC = () => {
    return <FeedList type="event" />;
};
